/* Hallmark · component-scope redesign: auth surface · genre: editorial · theme: host_ui.css (design.md tokens)
 * pre-emit critique: P5 H5 E5 S5 R5 V4
 */
import React, { ReactNode } from "react";

import { BrandMark } from "@javascript/components/BrandMark";

// One surface, not two panels. The auth screens used to be a split — a tinted
// aside behind a vertical rule, a second column for the form, a footer strip
// closing both. Three edges for a page with one job. Now the shell paints
// nothing of its own: it inherits the shell's `bg-muted` ground, and the only
// edge left on screen belongs to the card the form sits in.
export function AuthShell({
  brandMotifPath,
  children,
}: {
  brandMotifPath: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-1 flex-col px-6 py-10 sm:px-10 sm:py-12 lg:px-16">
      {/* With no footer, this is the only way back out to the marketing site. */}
      <a href="/" className="self-start font-serif text-xl font-semibold tracking-tight">
        <BrandMark size="md" className="text-xl" />
      </a>

      <div className="mt-10 flex flex-1 flex-col justify-center lg:mt-0 lg:grid lg:grid-cols-2 lg:items-center lg:gap-16">
        <div
          className="landing-reveal hidden lg:block"
          style={{ "--reveal-index": 1 } as React.CSSProperties}
        >
          <img
            src={brandMotifPath}
            alt=""
            aria-hidden
            width={440}
            height={440}
            className="mb-8 w-32"
          />
          <p className="max-w-lg font-serif text-4xl font-semibold leading-tight tracking-tight text-balance xl:text-5xl">
            A page worth keeping, for the best day of your life.
          </p>
          <p className="mt-5 max-w-md leading-relaxed text-muted-foreground">
            Design the page, share one link, and keep every reply in one place.
          </p>
        </div>

        <section
          data-auth-column
          className="landing-reveal mx-auto w-full max-w-md"
          style={{ "--reveal-index": 0 } as React.CSSProperties}
        >
          {children}
        </section>
      </div>
    </div>
  );
}
